import { JobCardSkeleton } from './JobCardSkeleton';

export const JobsTabSkeleton = () => {
  return (
    <div className='py-3'>
      {/* First date section */}
      <div className='mb-1 whitespace-nowrap py-1 text-center'>
        <div className='mx-auto h-3 w-20 animate-pulse rounded bg-gray-200'></div>
      </div>
      <JobCardSkeleton />
      <JobCardSkeleton />
      <JobCardSkeleton />

      {/* Second date section */}
      <div className='mb-1 mt-4 whitespace-nowrap py-1 text-center'>
        <div className='mx-auto h-3 w-24 animate-pulse rounded bg-gray-200'></div>
      </div>
      <JobCardSkeleton />
      <JobCardSkeleton />

      {/* Third date section */}
      <div className='mb-1 mt-4 whitespace-nowrap py-1 text-center'>
        <div className='mx-auto h-3 w-16 animate-pulse rounded bg-gray-200'></div>
      </div>
      <JobCardSkeleton />
    </div>
  );
};
